import React from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import { Footer, Header } from "../";
import { FaHome } from "../../assets/icons/index";
import { isActiveStyles, isNotActiveStyles } from "../../utils/styles";
import {
  Blogs,
  Concepts,
  Events,
  Forums,
  Home,
  NewConcept,
  NewTrainer,
  Trainers,
} from "../Daashboard";

const Dashboard = () => {
  return (
    <div className="w-full bg-primary flex items-center justify-center flex-col">
      <Header />
      <ul className="w-full md:w-656 overflow-x-scroll scrollbar-none my-8 flex items-center justify-evenly gap-3">
        {/* prettier-ignore */}
        <NavLink to={"/dashboard"} className={({ isActive }) => isActive ? isActiveStyles : isNotActiveStyles} > <FaHome className="-rotate-0 text-3xl" /> </NavLink>
        {/* prettier-ignore */}
        <NavLink to={"/dashboard/concepts"} className={({ isActive }) => isActive ? isActiveStyles : isNotActiveStyles} > Concepts </NavLink>
        {/* prettier-ignore */}
        <NavLink to={"/dashboard/trainers"} className={({ isActive }) => isActive ? isActiveStyles : isNotActiveStyles} > Trainers </NavLink>
        {/* prettier-ignore */}
        <NavLink to={"/dashboard/forums"} className={({ isActive }) => isActive ? isActiveStyles : isNotActiveStyles} > Forums</NavLink>
        {/* prettier-ignore */}
        <NavLink to={"/dashboard/blogs"} className={({ isActive }) => isActive ? isActiveStyles : isNotActiveStyles} > Blogs </NavLink>
        {/* prettier-ignore */}
        <NavLink to={"/dashboard/events"} className={({ isActive }) => isActive ? isActiveStyles : isNotActiveStyles} > Events </NavLink>
      </ul>

      <main className="my-4 w-full flex items-center justify-center px-12 md:px-32">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/concepts" element={<Concepts />} />
          <Route path="/trainers" element={<Trainers />} />
          <Route path="/forums" element={<Forums />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/newConcept" element={<NewConcept />} />
          <Route path="/newTrainer" element={<NewTrainer />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default Dashboard;
